/**
 * 配車計画 ドライバー配車 車両
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocate/entries/drivers`

 const allocate_entry_driver_schedule_vehicle = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    show ({ commit }, { driver_id, id, target_date }) {
      let params = { target_date: target_date }
      const api_path = `${API_PATH}/${driver_id}/schedules/${id}/vehicles`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit }, { driver_id, id, params }) {
      const api_path = `${API_PATH}/${driver_id}/schedules/${id}/vehicles`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},

 }

 export default allocate_entry_driver_schedule_vehicle
